export const ENGAGE_SURVEY = 'EngageSurvey'
export const ENPS_SURVEY = 'eNPS'
export const surveysUrl =
  process.env.SURVEYS_URL || 'https://surveys.15five.com'
